export default "__VITE_ASSET__ykesWYG7__"